/**
 * Button colours for sweetalert2 confirm dialogs, from the theme tokens.
 *
 * Spread it into a `Swal.fire({ … })` call instead of writing hex literals:
 *
 *   Swal.fire({ title: 'Delete?', showCancelButton: true, ...confirmColors('danger') })
 *
 * sweetalert2 applies these as CSS custom properties on the buttons, so a
 * `var(--token)` value resolves like any other stylesheet value.
 *
 * `tone` is what confirming does: `danger` deletes or deactivates, `success`
 * restores or activates, `warning` proceeds with a caveat, `primary` is
 * everything else. Cancel is always the neutral secondary colour.
 */
export type ConfirmTone = 'primary' | 'danger' | 'success' | 'warning';

const CONFIRM: Record<ConfirmTone, string> = {
  primary: 'var(--accent)',
  danger: 'var(--neg)',
  success: 'var(--green-600)',
  warning: 'var(--warn)',
};

export const confirmColors = (tone: ConfirmTone = 'primary') => ({
  confirmButtonColor: CONFIRM[tone],
  cancelButtonColor: 'var(--neutral-solid)',
});

export default confirmColors;
